module.exports = __webpack_public_path__ + "img/trash-can-outline-edit.267a5298.svg";